// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2EAqP","inputWrap":"Table_inputWrap__2hixf","col":"Table_col__1iypr","bmiTooltip":"Table_bmiTooltip__1KhZm"};